const styles = () => ({
  root: {
    overflow: 'hidden',
    borderRadius: '50%',
    flex: 'none',
  },

  image: {
    display: 'block',
    maxWidth: '100%',
  },
});

export default styles;
